import Axios, { AxiosResponse } from "axios";
import { BASE_API_PATH } from "../enum/base.enum";
import { SeonReq } from "../request/fraud.req";

export const FraudService = {
    updateSeonData(checkoutId: string, seonReq: SeonReq): Promise<AxiosResponse<any>> {
        return Axios.post(`${BASE_API_PATH}/fraud/seon?checkoutId=${checkoutId}`, seonReq)
    }
}